export default "__VITE_ASSET___HDAaa7a__"